import React from 'react';

const RowLayout3Components = ({ children }) => {
  const [A, B, C] = React.Children.toArray(children);

  return (
    <div style={{ display: 'flex', flexFlow: 'row nowrap' }}>
      <div style={{ width: '40%' }}>
        {A}
      </div>
      <div style={{ display: 'flex', flexFlow: 'row nowrap', margin: '0 20px 0 20px', padding: '0 0 0 0', width: 48 }}>
        {B}
      </div>
      <div style={{ width: '60%', display: 'flex' }}>
        {C}
      </div>
    </div>
  );
};

export default RowLayout3Components;
